import { useState, useEffect } from "react";
import {
  Container,
  Card,
  Table,
  Row,
  Col,
  Form,
  Button,
} from "react-bootstrap";
import ReferralService from "../services/referral.service";
import ReferralFilter from "../components/referral/ReferralFilter";
import Loading from "../components/Util/Loading";
import { formatPretty } from "../helpers/dateHelper";

function Referral(props) {
  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const [mobile, setMobile] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  const [createdFrom, setCreatedFrom] = useState("");
  const [createdTo, setCreatedTo] = useState("");
  const [usedFrom, setUsedFrom] = useState("");
  const [usedTo, setUsedTo] = useState("");

  const [manualMobile, setManualMobile] = useState("");
  const [manualInviteCode, setManualInviteCode] = useState("");
  const [manualApplying, setManualApplying] = useState(false);
  const [manualValidated, setManualValidated] = useState(false);

  const styleGreen = { color: "green" };
  const styleRed = { color: "red" };

  const handleSearch = async (overrides = {}) => {
    const searchMobile = overrides.mobile ?? mobile;
    const searchInviteCode = overrides.inviteCode ?? inviteCode;
    if (!searchMobile.trim() && !searchInviteCode.trim()) {
      props.notify(
        "tr",
        "danger",
        "Утасны дугаар эсвэл промо код оруулна уу.",
      );
      setInvites([]);
      setSearched(false);
      return;
    }
    try {
      setLoading(true);
      setSearched(true);
      const data = await ReferralService.searchInvites({
        mobile: searchMobile,
        inviteCode: searchInviteCode,
        createdFrom,
        createdTo,
        usedFrom,
        usedTo,
      });
      setInvites(data.invites || []);
    } catch (err) {
      props.notify("tr", "danger", err.message);
      setInvites([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const consumerMobile = props.consumer?.mobile;
    if (!consumerMobile) return;
    const mobileStr = String(consumerMobile);
    setMobile(mobileStr);
    handleSearch({ mobile: mobileStr });
  }, [props.consumer?.mobile]);

  const handleManualApply = async (e) => {
    e.preventDefault();
    if (manualMobile.length !== 8 || !manualInviteCode.trim()) {
      setManualValidated(true);
      return;
    }
    try {
      setManualApplying(true);
      const result = await ReferralService.manualApplyInvite(
        manualMobile,
        manualInviteCode,
      );
      props.notify("tr", "success", result.message || "Амжилттай.");
      setManualInviteCode("");
      setManualValidated(false);
      setMobile(manualMobile);
      handleSearch({ mobile: manualMobile });
    } catch (err) {
      props.notify("tr", "danger", err.message);
    } finally {
      setManualApplying(false);
    }
  };

  return (
    <Container fluid>
      <Row>
        <Col md="12" className="align-items-start">
          <Card className="striped-tabled-with-hover">
            <Card.Header>
              <Card.Title as="h4">Найз урих (Referral) хайх</Card.Title>
              <ReferralFilter
                mobile={mobile}
                setMobile={setMobile}
                inviteCode={inviteCode}
                setInviteCode={setInviteCode}
                createdFrom={createdFrom}
                setCreatedFrom={setCreatedFrom}
                createdTo={createdTo}
                setCreatedTo={setCreatedTo}
                usedFrom={usedFrom}
                setUsedFrom={setUsedFrom}
                usedTo={usedTo}
                setUsedTo={setUsedTo}
                handleSearch={handleSearch}
              />
            </Card.Header>
            <Card.Body className="table-full-width table-responsive px-3">
              <Table
                className="table-hover"
                style={{
                  fontSize: "12px",
                }}
              >
                <thead>
                  <tr>
                    <th className="border-0">Эзэмшигчийн утас</th>
                    <th className="border-0">Промо код</th>
                    <th className="border-0">Үүссэн огноо</th>
                    <th className="border-0">Ашигласан эсэх</th>
                    <th className="border-0">Ашигласан утас</th>
                    <th className="border-0">Ашигласан огноо</th>
                  </tr>
                </thead>
                {invites.length === 0 ? (
                  <tbody>
                    <tr>
                      <td align="center" colSpan="6">
                        <h6>
                          {searched ? "Мэдээлэл олдсонгүй." : "Хайлт хийнэ үү."}
                        </h6>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody style={{ wordBreak: "break-all" }}>
                    {invites.map((invite, key) => (
                      <tr key={key}>
                        <td>{invite.owner_mobile || ""}</td>
                        <td>{invite.invite_code}</td>
                        <td>{formatPretty(invite.created_at)}</td>
                        <td style={invite.is_used ? styleGreen : styleRed}>
                          {invite.is_used ? "Ашигласан" : "Ашиглаагүй"}
                        </td>
                        <td>{invite.used_mobile || ""}</td>
                        <td>
                          {invite.used_at ? formatPretty(invite.used_at) : ""}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </Table>
              <Loading loading={loading} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <Card>
            <Card.Header>
              <Card.Title as="h4">Промо код нөхөж оруулах (CRM)</Card.Title>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handleManualApply}>
                <Form.Row className="align-items-start flex-nowrap">
                  <Form.Group as={Col} xs="4" sm="3">
                    <Form.Label>Утасны дугаар</Form.Label>
                    <Form.Control
                      type="text"
                      maxLength={8}
                      value={manualMobile}
                      onChange={(e) =>
                        setManualMobile(
                          e.target.value.replace(/\D/g, "").slice(0, 8),
                        )
                      }
                      isInvalid={manualValidated && manualMobile.length !== 8}
                      style={{ transition: "none" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      8 оронтой утасны дугаар оруулна уу.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} xs="4" sm="3">
                    <Form.Label>Промо код</Form.Label>
                    <Form.Control
                      type="text"
                      maxLength={6}
                      value={manualInviteCode}
                      onChange={(e) =>
                        setManualInviteCode(e.target.value.toUpperCase())
                      }
                      isInvalid={manualValidated && !manualInviteCode.trim()}
                      style={{ transition: "none" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Промо код оруулна уу.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} xs="4" sm="3">
                    <Form.Label className="invisible">&nbsp;</Form.Label>
                    <Button
                      variant="primary"
                      className="btn btn-sm"
                      size="md"
                      type="submit"
                      style={{
                        opacity: 1,
                        color: "#3472F7",
                        borderColor: "#3472F7",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      disabled={manualApplying}
                    >
                      {manualApplying ? "Хийж байна..." : "Оруулах"}
                    </Button>
                  </Form.Group>
                </Form.Row>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Referral;
